export const MAX_DAYS_PER_VIEW = 5

export const LAST_MONTH_INDEX = 11
export const FIRST_MONTH_INDEX = 0
export const UNPERMITTED_INDEXES = [-1, 12]
